import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string'
import NavItem from './collection-nav-item'
import { useSelector } from 'react-redux';
import { useViewport } from '../../../utils';
import { DESKTOP_ITEMS_PER_PAGE } from '../config';

const CollectionNav = () => {
  const { isMobile } = useViewport()
  const history = useHistory()
  const location = useLocation()
  const { search } = location
  const query = qs.parse(search)
  const currentCollection = query.collection
  const { countData } = useSelector(state => state.search)

  const changeCollection = (key) => {
    console.log('[A] change collection!')
    const newQuery = {
      ...query,
      collection: key,
      offset: 0,
      limit: DESKTOP_ITEMS_PER_PAGE[key]
    }

    console.log('[A] history pushing...', newQuery.limit)
    history.push({
      pathname: '/search',
      search: qs.stringify(newQuery)
    })
  }

  const navItems = [
    {
      label: "Program",
      collection: "programs"
    },
    {
      label: "Organization",
      collection: "organizations"
    },
    {
      label: "Event",
      collection: "events"
    },
    {
      label: "Resources",
      collection: "resources"
    },
    {
      label: "Blog",
      collection: "blogs"
    }
  ]

  return (
    <div className="flex overflow-x-auto border-b mb-5 lg:mb-8">
      {
        navItems.map(t => (
          <NavItem
            key={t.label}
            mobile={isMobile}
            label={t.label}
            count={countData[t.collection]}
            isActive={currentCollection === t.collection ? true : false}
            onClick={() => changeCollection(t.collection)}
          />
        ))
      }
    </div>
  )
}

export default CollectionNav
